import { render, staticRenderFns } from "./terminatePhoneNumberBlockDialog.vue?vue&type=template&id=3e38287a&scoped=true"
import script from "./terminatePhoneNumberBlockDialog.vue?vue&type=script&lang=ts"
export * from "./terminatePhoneNumberBlockDialog.vue?vue&type=script&lang=ts"
import style0 from "./terminatePhoneNumberBlockDialog.vue?vue&type=style&index=0&id=3e38287a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38287a",
  null
  
)

export default component.exports